/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrow-left': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path d="M10.8334 4.94165L5.77502 9.99998L10.8334 15.0583L12.0834 13.8083L8.27502 9.99998L12.0834 6.19165L10.8334 4.94165Z" fill="#010005"/>'
  }
})
